import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SplashscreenService } from 'src/app/shared/services/splashscreen.service';

export interface RecentlyAddedAssetApiItem {
    assetId?: number | string;
    assetID?: number | string;
    AssetId?: number | string;
    id?: number | string;
    assetName?: string;
    AssetName?: string;
    name?: string;
}

export interface RecentlyAddedAssetItem {
    assetId: string;
    assetName: string;
}

@Injectable()
export class RecentlyAddedAssetsDataService {
    constructor(
        private readonly http: HttpClient,
        private readonly splashscreenService: SplashscreenService
    ) { }

    getAssets(): Observable<RecentlyAddedAssetItem[]> {
        return this.http.get<RecentlyAddedAssetApiItem[]>('/api/assets/recentlyAdded').pipe(
            map(items => this.normalizeItems(items)),
            tap({
                next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
                error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
            })
        );
    }

    private normalizeItems(items: RecentlyAddedAssetApiItem[] | null | undefined): RecentlyAddedAssetItem[] {
        if (!Array.isArray(items)) {
            return [];
        }

        return items
            .map(item => this.normalizeItem(item))
            .filter((item): item is RecentlyAddedAssetItem => !!item);
    }

    private normalizeItem(item: RecentlyAddedAssetApiItem | null | undefined): RecentlyAddedAssetItem | null {
        const assetId = String(item?.assetId ?? item?.assetID ?? item?.AssetId ?? item?.id ?? '').trim();
        if (!assetId) {
            return null;
        }

        const assetName = String(item?.assetName ?? item?.AssetName ?? item?.name ?? '').trim();

        return {
            assetId,
            assetName: assetName || `Asset ${assetId}`
        };
    }
}
